/* @flow */
import { Map } from 'immutable';

import {
  AUTHENTICATION_CHAT_FETCH_REQUEST,
  AUTHENTICATION_CHAT_FETCH_FAILURE,
  AUTHENTICATION_CHAT_FETCH_SUCCESS,
} from './action';

const initialState = Map({
  type: '',
  payload: {},
});

function reducer(state = initialState, action): any {
  const { type } = action;

  if (type === AUTHENTICATION_CHAT_FETCH_REQUEST) {
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => true)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], {});
  }

  if (type === AUTHENTICATION_CHAT_FETCH_FAILURE) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => false)
      .setIn(['payload'], payload);
  }

  if (type === AUTHENTICATION_CHAT_FETCH_SUCCESS) {
    const { payload } = action;
    return state
      .updateIn(['type'], () => type)
      .updateIn(['isLoading'], () => false)
      .updateIn(['isLoaded'], () => true)
      .setIn(['payload'], payload);
  }

  return state;
}

export default reducer;
